import { createSelector } from 'reselect';

import {
  createEventMetaDataCloudSelector,
  eventMetaDataSelector,
} from '../tracking/selectors';
import { COVERAGE_CLOUD_TYPE } from '../../../constants';

const userStore = (store) => store.user;

const getEmptyStatesFor = (coverageState) => Object.entries(coverageState).reduce(
  (output, [key, value]) => ({
    ...output,
    [key]: !value?.get('coverage').size,
  }),
  {},
);

export const createCoverageSelector = ({
  coverageStore,
  source,
  productSubArea,
}) => createSelector(
  [coverageStore, eventMetaDataSelector],
  (coverage, eventMetaData) => ({
    coverage: coverage.get('coverage'),
    loading: coverage.get('loading'),
    maxCount: coverage.get('maxCount'),
    sort: coverage.get('sort'),
    eventMetaData: {
      ...eventMetaData,
      sku_type: source,
      product_sub_area: productSubArea,
    },
  }),
);

export const createCoverageParamsSelector = (getFiltersParams, coverageStore) => createSelector(
  [getFiltersParams, coverageStore],
  (filtersParams, coverage) => ({
    ...filtersParams,
    sort: coverage.getIn(['sort', 'direction']),
    sort_by: coverage.getIn(['sort', 'field']),
  }),
);

export const createCoverageContainerSelector = (coverageStore) => createSelector(
  [coverageStore],
  (coverage) => ({
    isCoverageEmpty: getEmptyStatesFor(coverage),
    isLoadingCSV: Object.values(coverage).reduce(
      (isLoading, store) => isLoading || store.get('loadingCSV'),
      false,
    ),
  }));

export const coverageCommonDataSelector = createSelector(
  [userStore, createEventMetaDataCloudSelector(COVERAGE_CLOUD_TYPE)],
  (user, { eventMetaData }) => ({
    isCoverageEnabled: user?.isOrgAdmin() || user?.isAdmin(),
    eventMetaData,
  }),
);
